module.exports = __webpack_public_path__ + "files/1b27964ad692434f271a1dcc82277351.png";